import { render, staticRenderFns } from "./HistoryService.vue?vue&type=template&id=9ca25030&scoped=true"
import script from "./HistoryService.vue?vue&type=script&lang=js"
export * from "./HistoryService.vue?vue&type=script&lang=js"
import style0 from "./HistoryService.vue?vue&type=style&index=0&id=9ca25030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca25030",
  null
  
)

export default component.exports